import React from 'react';
import type { AirtableInventoryReceivedItem } from '../../types/airtableTypes';
import './ReceiptInfoModal.css';

interface ReceiptInfoModalProps {
  readonly item: AirtableInventoryReceivedItem | null;
  readonly formatDate: (dateStr: string | null | undefined) => string;
  readonly onClose: () => void;
}

function ReceiptInfoModal({ item, formatDate, onClose }: ReceiptInfoModalProps): React.ReactElement | null {
  if (!item) return null;

  const receivedBy = item.receivedByName?.trim() || 'Unknown';
  const isRolledBack = item.rolledBackAt != null && item.rolledBackAt !== '';

  return (
    <div className="shipment-item-confirm-overlay" onClick={onClose} role="presentation">
      <div
        className="shipment-item-confirm-dialog receipt-info-modal"
        role="dialog"
        aria-labelledby="receipt-info-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="receipt-info-title">Receipt Info</h3>
        <dl className="receipt-info-fields">
          <div className="receipt-info-row">
            <dt>Person Received</dt>
            <dd>{receivedBy}</dd>
          </div>
          <div className="receipt-info-row">
            <dt>Date received</dt>
            <dd>{formatDate(item.createdAt) || '—'}</dd>
          </div>
          <div className="receipt-info-row">
            <dt>Units Received</dt>
            <dd>{item.quantity}</dd>
          </div>
          {isRolledBack ? (
            <>
              <div className="receipt-info-row receipt-info-row--rolled-back">
                <dt>TRANSACTION ROLLED BACK</dt>
                <dd></dd>
              </div>
              <div className="receipt-info-row">
                <dt>Date of Rollback</dt>
                <dd>{formatDate(item.rolledBackAt) || '—'}</dd>
              </div>
            </>
          ) : null}
        </dl>
        <div className="shipment-item-confirm-buttons">
          <button
            type="button"
            className="shipment-item-confirm-btn shipment-item-confirm-btn--no"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReceiptInfoModal;
